import { IConsents } from '../../../types';
export type ConsentsState = IConsents;

export enum ConsentsActionTypes {
  UPDATE_CONSENTS_FIELD = '@@visa/consents/UPDATE_CONSENTS_FIELD',
}

export enum Pages {
  PAGE1 = 'uni-c-step1',
  PAGE2 = 'uni-c-step2',
  PAGE3 = 'uni-c-step3',
  PAGE4 = 'uni-c-step4',
}
